var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1001 31.5996H14.1001C14.9285 31.5996 15.6001 30.928 15.6001 30.0996V3.09961C15.6001 2.27118 14.9285 1.59961 14.1001 1.59961H12.1001C11.2717 1.59961 10.6001 2.27118 10.6001 3.09961V30.0996C10.6001 30.928 11.2717 31.5996 12.1001 31.5996ZM28.1001 31.5996H26.1001C25.2717 31.5996 24.6001 30.928 24.6001 30.0996V8.09961C24.6001 7.27118 25.2717 6.59961 26.1001 6.59961H28.1001C28.9285 6.59961 29.6001 7.27118 29.6001 8.09961V30.0996C29.6001 30.928 28.9285 31.5996 28.1001 31.5996ZM19.1001 31.5996H21.1001C21.9285 31.5996 22.6001 30.928 22.6001 30.0996V15.0996C22.6001 14.2712 21.9285 13.5996 21.1001 13.5996H19.1001C18.2717 13.5996 17.6001 14.2712 17.6001 15.0996V30.0996C17.6001 30.928 18.2717 31.5996 19.1001 31.5996ZM5.1001 31.5996H7.1001C7.92852 31.5996 8.6001 30.928 8.6001 30.0996V21.0996C8.6001 20.2712 7.92852 19.5996 7.1001 19.5996H5.1001C4.27167 19.5996 3.6001 20.2712 3.6001 21.0996V30.0996C3.6001 30.928 4.27167 31.5996 5.1001 31.5996Z",
    fill: "#1C1C1C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.e72455f96573834e86777aa43983a131.svg";
export { ForwardRef as ReactComponent };